/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Icon, View } from "@aws-amplify/ui-react";
export default function Footer(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="320px"
      height="50px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      backgroundColor="rgba(255,255,255,1)"
      {...rest}
      {...getOverrideProps(overrides, "Footer")}
    >
      <View
        width="60px"
        height="13.87px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        overflow="hidden"
        position="absolute"
        top="calc(50% - 6.93px - 0.07px)"
        left="calc(50% - 30px - 0px)"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "voozy_logo_g 1")}
      >
        <Icon
          width="16.31px"
          height="13.87px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 16.314624786376953,
            height: 13.868896484375,
          }}
          paths={[
            {
              d: "M4.64108 13.8688C3.92677 13.8533 3.31339 13.3797 3.11929 12.6906C2.8456 11.7143 2.70002 10.4157 2.76796 9.53253C2.79125 9.22972 3.04553 8.99486 3.34833 8.99486C3.36192 8.99486 3.37745 8.99486 3.39104 8.99486C3.54632 9.0065 3.68802 9.07832 3.79089 9.19673C3.89183 9.31513 3.9423 9.46459 3.93065 9.61988C3.87436 10.3575 4.01023 11.5435 4.24316 12.3762C4.29751 12.5703 4.46832 12.7023 4.66825 12.7062L4.73619 12.7062C5.37286 12.7062 6.11822 12.5062 6.68695 12.1801C6.79177 12.12 6.86359 12.0229 6.89076 11.9064C6.91988 11.7822 6.89853 11.6541 6.82671 11.5454C6.26186 10.6855 5.89694 9.7441 5.74166 8.74834C5.73001 8.66876 5.66207 8.61053 5.58249 8.60859C5.32627 8.60276 4.97688 8.59694 4.5052 8.59112C3.70743 8.57947 2.94071 8.57365 2.94071 8.57365C2.06724 8.57171 1.31993 8.26696 0.780315 7.69435C0.273699 7.15668 -0.00193087 6.42102 1.01824e-05 5.61936C1.01824e-05 4.79053 0.298933 4.0374 0.836606 3.49973C1.37234 2.96593 2.10023 2.68254 2.93877 2.68254L5.53202 2.6903C6.51226 2.6903 7.59731 2.29821 8.75612 1.52567L8.95799 1.39174C10.1246 0.615315 11.0446 0 12.2345 0C13.5253 0.00388211 14.6395 0.673547 15.3732 1.89059C15.9846 2.90188 16.3185 4.24121 16.3146 5.664C16.3107 7.08486 15.9691 8.42419 15.3538 9.43159C14.6162 10.6389 13.502 11.3047 12.2209 11.3047C11.6172 11.3047 11.0524 11.1572 10.5399 10.8719C10.5264 10.8641 10.5128 10.8602 10.4992 10.8563C10.0023 10.5613 9.56554 10.2857 9.18121 10.0411C8.66489 9.71499 8.22815 9.43742 7.80306 9.21225C7.66524 9.13849 7.56431 9.01815 7.51966 8.86869C7.47502 8.71923 7.48861 8.562 7.56237 8.42613C7.6633 8.2359 7.86129 8.11556 8.07675 8.11556C8.13304 8.11556 8.18933 8.12332 8.24368 8.14079C8.25921 8.14467 8.27474 8.14856 8.2922 8.14856C8.33491 8.14856 8.37761 8.13109 8.40867 8.10003C8.45137 8.05733 8.46884 7.99521 8.45137 7.93698C8.24562 7.22267 8.13692 6.43072 8.13886 5.64265C8.1408 4.99434 8.21456 4.35961 8.35432 3.75789C8.41643 3.49196 8.64936 3.30756 8.92111 3.30756C8.95216 3.30756 8.98128 3.3095 9.01234 3.31532C9.01234 3.31532 11.7298 3.74624 12.4499 3.86464C13.1662 3.98305 13.6476 4.69736 13.6476 5.64265C13.6476 6.58795 13.1759 7.27702 12.4732 7.41484C12.4635 7.41484 12.4558 7.41872 12.4461 7.4226L10.6331 7.71182C10.6021 7.71764 10.571 7.71958 10.5399 7.71958C10.2527 7.71958 10.012 7.51383 9.9654 7.2285C9.94016 7.07515 9.97704 6.92181 10.0683 6.79564C10.1595 6.66947 10.2934 6.58601 10.4468 6.56271L10.7554 6.51419C10.802 6.50642 10.8428 6.47925 10.868 6.44043C10.8932 6.39966 10.901 6.35114 10.8874 6.30649C10.8641 6.22109 10.8428 6.1318 10.8292 6.04251C10.7787 5.72612 10.9942 5.42525 11.3105 5.37479C11.3416 5.36896 11.3727 5.36702 11.4037 5.36702C11.691 5.36702 11.9317 5.57277 11.9783 5.85617C11.9957 5.96681 12.0326 6.07939 12.0753 6.15897C12.1044 6.21138 12.1588 6.24438 12.219 6.24438C12.2791 6.24438 12.3335 6.21138 12.3626 6.16091C12.3898 6.11433 12.4771 5.93575 12.4771 5.64459C12.4771 5.35343 12.384 5.1438 12.3296 5.07198C12.3044 5.03898 12.2675 5.01763 12.2267 5.00987C11.7221 4.9264 10.3885 4.71483 9.54807 4.58089C9.5403 4.58089 9.5306 4.57895 9.52283 4.57895C9.4879 4.57895 9.45296 4.5906 9.42384 4.61195C9.3889 4.63913 9.36561 4.67795 9.35979 4.72259C9.32096 5.02345 9.30155 5.33402 9.29961 5.64459C9.29185 8.72893 10.8039 10.1362 12.2131 10.1401C13.1021 10.1401 13.8242 9.69752 14.358 8.82404C14.8569 8.00686 15.1461 6.85387 15.148 5.66012C15.1558 2.57578 13.6437 1.16657 12.2345 1.16463C11.394 1.16463 10.6797 1.64213 9.60048 2.36227L9.39861 2.49814C8.04763 3.39879 6.74712 3.85688 5.53785 3.85688C5.45826 3.85688 5.39033 3.91511 5.3748 3.99275C5.27968 4.52654 5.23116 5.08169 5.23116 5.64265C5.23116 5.86975 5.23892 6.10074 5.25445 6.32979C5.2758 6.65006 5.03511 6.92957 4.71484 6.95092C4.70125 6.95092 4.68766 6.95092 4.67407 6.95092C4.36933 6.95092 4.11505 6.71217 4.0937 6.40937C4.07623 6.15121 4.06652 5.89305 4.06652 5.64071C4.06652 5.10692 4.10729 4.56925 4.18881 4.04128C4.19658 3.99469 4.18299 3.94617 4.15193 3.90929C4.12087 3.87241 4.07429 3.85106 4.0277 3.85106L2.95236 3.84717C2.41857 3.84717 1.97018 4.01216 1.65767 4.32467C1.33934 4.64107 1.16464 5.1011 1.1627 5.6213C1.1627 6.12403 1.32381 6.5763 1.62273 6.89269C1.93718 7.22655 2.39139 7.40513 2.93683 7.40513C2.9543 7.40513 3.72102 7.41095 4.51685 7.4226C6.13957 7.44201 6.27545 7.46336 6.33368 7.47113C6.60349 7.51189 6.81118 7.73899 6.82865 8.01074C6.89464 9.05115 7.22074 10.0236 7.79529 10.901C8.04181 11.2737 8.12333 11.7376 8.01852 12.1724C7.91564 12.6052 7.64583 12.9663 7.25956 13.1875C6.51614 13.6126 5.56502 13.8669 4.71678 13.8669L4.63719 13.8669L4.64108 13.8688Z",
              fill: "rgba(160,160,160,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="0%"
          left="0%"
          right="72.81%"
          {...getOverrideProps(overrides, "Vector38743554")}
        ></Icon>
        <View
          padding="0px 0px 0px 0px"
          width="40.65px"
          height="12.07px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="8.85%"
          bottom="4.09%"
          left="32.24%"
          right="0%"
          {...getOverrideProps(overrides, "Group38743555")}
        >
          <Icon
            width="7.54px"
            height="7.54px"
            viewBox={{ minX: 0, minY: 0, width: 7.5390625, height: 7.5390625 }}
            paths={[
              {
                d: "M3.76953 7.53906C1.69066 7.53906 0 5.8484 0 3.76953C0 1.69066 1.69066 0 3.76953 0C5.8484 0 7.53906 1.69066 7.53906 3.76953C7.53906 5.8484 5.8484 7.53906 3.76953 7.53906L3.76953 7.53906ZM3.76953 1.41697C2.47291 1.41697 1.53344 2.47291 1.53344 3.76953C1.53344 5.06616 2.47291 6.12209 3.76953 6.12209C5.06616 6.12209 6.00563 5.06616 6.00563 3.76953C6.00563 2.47291 5.06616 1.41697 3.76953 1.41697Z",
                fill: "rgba(160,160,160,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="17.56%"
            bottom="20%"
            left="21.01%"
            right="60.45%"
            {...getOverrideProps(overrides, "Vector38743556")}
          ></Icon>
          <Icon
            width="7.54px"
            height="7.54px"
            viewBox={{ minX: 0, minY: 0, width: 7.5390625, height: 7.5390625 }}
            paths={[
              {
                d: "M3.76953 7.53906C1.69066 7.53906 0 5.8484 0 3.76953C0 1.69066 1.69066 0 3.76953 0C5.8484 0 7.53906 1.69066 7.53906 3.76953C7.53906 5.8484 5.8484 7.53906 3.76953 7.53906ZM3.76953 1.41697C2.47291 1.41697 1.53343 2.47291 1.53343 3.76953C1.53343 5.06616 2.47291 6.12209 3.76953 6.12209C5.06616 6.12209 6.00563 5.06616 6.00563 3.76953C6.00563 2.47291 5.06616 1.41697 3.76953 1.41697Z",
                fill: "rgba(160,160,160,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="17.56%"
            bottom="20%"
            left="43.77%"
            right="37.69%"
            {...getOverrideProps(overrides, "Vector38743557")}
          ></Icon>
          <Icon
            width="6.19px"
            height="7.03px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 6.188087463378906,
              height: 7.028564453125,
            }}
            paths={[
              {
                d: "M5.41166 7.02857L0.854067 7.02857C0.560967 7.02857 0.29116 6.86358 0.159168 6.59959C0.0271762 6.33755 0.0562911 6.0231 0.230986 5.78629L3.39685 1.55285L0.776423 1.55285C0.347449 1.55285 0 1.2054 0 0.776423C0 0.347449 0.347449 0 0.776423 0L4.94775 0C5.24085 0 5.51066 0.16499 5.64265 0.428974C5.77464 0.691016 5.74553 1.00547 5.57083 1.24228L2.40497 5.47572L5.41166 5.47572C5.84064 5.47572 6.18809 5.82317 6.18809 6.25214C6.18809 6.68112 5.84064 7.02857 5.41166 7.02857Z",
                fill: "rgba(160,160,160,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="19.68%"
            bottom="22.1%"
            left="66.62%"
            right="18.16%"
            {...getOverrideProps(overrides, "Vector38743558")}
          ></Icon>
          <Icon
            width="8.04px"
            height="9.85px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 8.041421890258789,
              height: 9.845703125,
            }}
            paths={[
              {
                d: "M4.02071 9.84582C3.70043 9.84582 3.4151 9.64977 3.2967 9.35279L0.0531902 1.05866C-0.102094 0.6588 0.0939517 0.208475 0.493809 0.0531901C0.893667 -0.102094 1.34399 0.0939523 1.49928 0.49381L4.02071 6.94006L6.54214 0.49381C6.69743 0.0939523 7.14775 -0.102094 7.54761 0.0531901C7.94747 0.210416 8.14352 0.660741 7.98823 1.05866L4.74278 9.35279C4.62632 9.64977 4.33904 9.84582 4.01877 9.84582L4.02071 9.84582Z",
                fill: "rgba(160,160,160,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="18.46%"
            left="0%"
            right="80.22%"
            {...getOverrideProps(overrides, "Vector38743559")}
          ></Icon>
          <View
            padding="0px 0px 0px 0px"
            width="5.84px"
            height="9.7px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="19.68%"
            bottom="0%"
            left="85.62%"
            right="0%"
            {...getOverrideProps(overrides, "Group38743560")}
          >
            <Icon
              width="5.84px"
              height="6.49px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 5.844520568847656,
                height: 6.490966796875,
              }}
              paths={[
                {
                  d: "M5.0681 6.49089L3.67054 6.49089C7.40454e-07 6.49089 0 3.4182 0 2.26133L0 0.776423C0 0.347449 0.347449 0 0.776423 0C1.2054 0 1.55285 0.347449 1.55285 0.776423L1.55285 2.26133C1.55285 4.0374 1.88088 4.93805 3.67054 4.93805L5.0681 4.93805C5.49707 4.93805 5.84452 5.2855 5.84452 5.71447C5.84452 6.14344 5.49707 6.49089 5.0681 6.49089Z",
                  fill: "rgba(160,160,160,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0.02%"
              bottom="33.05%"
              left="0%"
              right="0%"
              {...getOverrideProps(overrides, "Vector38743561")}
            ></Icon>
            <Icon
              width="4.11px"
              height="9.7px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 4.113224029541016,
                height: 9.697509765625,
              }}
              paths={[
                {
                  d: "M0.813427 9.69752C0.790134 9.69752 0.77461 9.69752 0.762964 9.69752C0.33399 9.68975 -0.00763446 9.33648 0.000129766 8.90751C0.00789399 8.48436 0.353402 8.14467 0.776552 8.14467C0.79014 8.14467 0.801784 8.14467 0.817313 8.14467C1.11429 8.14467 1.77231 8.0845 2.0887 7.88651C2.37986 7.70405 2.56038 7.24208 2.56038 6.92181L2.56038 0.776423C2.56038 0.347449 2.90783 0 3.3368 0C3.76577 0 4.11322 0.347449 4.11322 0.776423L4.11322 6.91987C4.11322 7.65553 3.7386 8.68235 2.91365 9.20061C2.17023 9.66646 1.0813 9.69752 0.81149 9.69752L0.813427 9.69752Z",
                  fill: "rgba(160,160,160,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="0%"
              left="29.62%"
              right="0%"
              {...getOverrideProps(overrides, "Vector38743562")}
            ></Icon>
          </View>
        </View>
      </View>
    </View>
  );
}
